import React from 'react';
import styles from './Banner.module.scss';
import helpers from '../../helpers/helpers';
import Image from 'next/image';
import {STATIC_PREFIX} from '../../constants/staticPrefix';

function Banner() {
  return <a className={styles.newBanner} href="https://vk.com/decimalchain?w=wall-193455162_4885">
    <Image src={`${STATIC_PREFIX || ''}/static/images/banner.png`} alt="banner" width={1190} height={201} unoptimized />
  </a>
  // return (
  //   <div className={styles.banner}>
  //     <Image className={styles.bannerLeftImg} src={`${STATIC_PREFIX || ''}/static/images/banner-left-img.png`} alt="left banner" layout="fill" unoptimized />
  //     <Image className={styles.bannerRightImg} src={`${STATIC_PREFIX || ''}/static/images/banner-right-img.png`} alt="right banner" layout="fill" unoptimized />
  //     <p className={styles.bannerSubtitle}>{helpers.getTranslationText('banner.subtitle') || 'NFT маркетплейс'}</p>
  //     <h1 className={styles.bannerTitle}>{helpers.getTranslationText('banner.title') || 'Исследуйте, собирайте, покупайте и продавайте NFTs'}</h1>
  //     {/*<a className={styles.bannerBtn} href="#">Исследовать</a>*/}
  //   </div>
  // );
}

export default Banner;
